/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint array-element-newline: ["error", "never"] */
import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';

const handleOnClick = (event) => {
    const { target } = event;

    if (target.selectionEnd <= 2) {
        target.setSelectionRange(2, 2);
    } else {
        const valueSelected = target.value.substring(0, target.selectionEnd);
        const match = valueSelected.match(/[A-Za-z0-9]/gi);
        if (match) {
            const lastDigitIndexInSelection =                valueSelected.lastIndexOf(match[match.length - 1]) + 1;
            target.setSelectionRange(
                lastDigitIndexInSelection,
                lastDigitIndexInSelection,
            );
        }
    }
};

const CanadaZipCodeMask = (props) => {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/[A-Za-z]/, /\d/, /[A-Za-z]/, ' ', /\d/, /[A-Za-z]/, /\d/]}
            placeholderChar={'\u2000'}
            onClick={(event) => handleOnClick(event)}
        />
    );
};

CanadaZipCodeMask.propTypes = {
    inputRef: PropTypes.func.isRequired,
};

export default CanadaZipCodeMask;
